import DOMPurify from 'dompurify'
import htmlParser from 'react-html-parser'
// date-fns/locale 묶음은 CommonJS라 쓰지 않는 언어까지 모두 번들에 들어가서, 쓰는 언어만 하나씩 가져온다
import ko from 'date-fns/locale/ko'
import ja from 'date-fns/locale/ja'

export function checkCorporateRegistrationNumber(value:number | string | ''):boolean {
    const numberMap = String(value).replace(/-/gi, '').split('').map(function (d){
		return parseInt(d, 10);
	});
	
	if(numberMap.length === 10){
		const keyArr = [1, 3, 7, 1, 3, 7, 1, 3, 5];
		let chk = 0;
		
		keyArr.forEach(function(d, i){
			chk += d * numberMap[i];
		});
		
		chk += parseInt((keyArr[8] * Number(numberMap[8]))/ 10, 10);

		return Math.floor(numberMap[9]) === ( (10 - (chk % 10) ) % 10);
	}
	
	return false;
}

// 주민 번호 체크 (- 는 빼고 보내야 한다)
export function checkJumin(value: number): boolean {
    const juminRule = /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))[1-8][0-9]{6}$/

    return juminRule.test(String(value))
}

// 생일 유효성 체크
export function checkBirthday(value:number | ''):boolean {
    return /([0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[1,2][0-9]|3[0,1]))/.test(String(value))
}

// intl html 적용
export function parseHtmlIntl(msg: any) {
    return msg ? htmlParser(sanitizeHtml(msg.replace(/<%/g, '<').replace(/%>/g, '>'))) : msg
}

// getIntlLocale
export function getIntlLocale(val: string) {
    if (!val) return 'ko'

    const [ locale ] = val.split('-')

    return locale
}


// 특정 컬럼을 키로 잡는다
export function getKeyOfArray(id: string, rows: any[]) {
    const ids = id.split('.')

    if (!rows) return rows

    return rows.reduce((acc, c) => {
        let key = null
        for (let i=0; i<ids.length; i++) {
            key = key === null ? c[ids[i]] : key[ids[i]]
        }
        
        // 이터럴이 안될경우 빈배열을 준다
        const _acc = acc[key] || []

        return { 
            ...acc,   
            [key]: [
                ..._acc,
                c
            ]
       
        }
    }, {})
}

export const delay = (time: number) => {
    return new Promise((resolve) => {
        setTimeout(resolve, time)
    })
}

export function fileSize(bytes: number, pos=0) {
    const Byte = Math.abs(Number(bytes))
    const sizes = ['Byte', 'KB', 'MB', 'GB', 'TB']
    if (Byte === 0) return '0 Byte'

    const i = Math.floor(Math.log(Byte) / Math.log(1024))

    const result = Number(Byte / Math.pow(1024, i)).toFixed(pos) + ' ' + sizes[i]

    return "1000 MB" === result ? "1 GB" : result
}

// 간단한 암호화
export function ListoEncrypt(theText: string) {
	let output = ''
	let Temp = []
	let Temp2 = []
    let rnd = 0
	const TextSize = theText.length

	for (let i = 0; i < TextSize; i++) {
		rnd = Math.round(Math.random() * 122) + 68;
		Temp[i] = theText.charCodeAt(i) + rnd;
		Temp2[i] = rnd;
	}
	for (let i = 0; i < TextSize; i++) {
		output += String.fromCharCode(Temp[i], Temp2[i]);
	}
	return output;
}

export function handleDisabledRightClick(e: Event) {
    e.preventDefault()
}

// { a: 17, b: 13, c: 16} value 기준으로 정렬
export function sortObject(props: { type?: string, obj: object }) {
    const { type='asc', obj } = props

    let sorted = Object.entries(obj).sort(([, a], [, b]) => a - b)
    
    if (type === 'desc') sorted = sorted.reverse()

    return sorted.reduce((r, [k, v]) => ({
        ...r,
        [k]: v
    }),{})
}

// ip4 validate
export const validationIP = (ip: string) => {
    const ipv4_regex = /^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$/gm

    return ipv4_regex.test(ip)
}

// 인앱 브라우저 인지 체크
export const isInAppBrowser = () => {
    if (!navigator) return false
    if (navigator.userAgent.indexOf('KAKAO') >= 0) return true
    if (navigator.userAgent.indexOf('[FB') >= 0) return true
    if (navigator.userAgent.indexOf('Instagram') >= 0) return true
    if (navigator.userAgent.indexOf('trill') >= 0) return true

    return false
}

export const getLocale = (locale: string) => {
    return locale.search('ko') === 0 ? ko : locale.search('ja') === 0 ? ja : ''
}


export const convertRgbaToRgb = (rgba: string, rgb: string) => {
    const [ r, g, b, a ]: any = rgba.split(',')
    const [ r2, g2, b2 ]: any = rgb.split(',')
    
    const r3 = Math.round(((1 - a) * r2) + (a * r))
    const g3 = Math.round(((1 - a) * g2) + (a * g))
    const b3 = Math.round(((1 - a) * b2) + (a * b))

    return `${r3}, ${g3}, ${b3}, 1`
}

// 파일명 구하기
export const getFilename = (path: string) => {
    if (!path) return ''

    const pathname = String(path).split(/[\\/]/).pop()
    const [ filename ] = pathname ? pathname.split('?') : [ '' ]
    
    return filename
}

// 경로 구하기
export const getPathname = (path: string) => {
    if (!path) return ''
    
    return path.substr(0, path.lastIndexOf("/"))
}


export const urlEncode = (str: string) => btoa(unescape(encodeURIComponent(str)));
export const urlDecode = (str: string) => decodeURIComponent(escape(atob(str)));

/**
 * 전달된 값이 몇 차원 배열인지 계산하는 함수
 *
 * - 배열이면 첫 번째 요소를 따라가면서 depth(차원)를 1씩 증가시킴
 * - 배열이 아닌 값이 나오는 순간 종료
 * - 결과적으로 배열이 중첩된 깊이(차원 수)를 반환
 *
 * 예시:
 * [1, 2, 3]        → 1차원
 * [[1], [2]]       → 2차원
 * [[[1]]]          → 3차원
 *
 * 주의:
 * - 첫 번째 요소 기준으로 판단하기 때문에
 *   비정형 배열([ [1], [[2]] ])에서는 정확하지 않을 수 있음
 * - 빈 배열([])은 1차원으로 간주됨
 */
export const getArrayDimension = (v: unknown): number => {
    let dim = 0;
    let current = v;
  
    while (Array.isArray(current)) {
      dim++;
      current = current[0];
    }
  
    return dim;
};


const ALLOWED_TAGS = [
	// b: 문구 파일의 <%b%> 강조 (빠져 있어서 굵게 표시가 모두 지워졌다)
	'a', 'b', 'i', 'strong', 'u', 'p', 's', 'sup', 'sub', 'br', 'span',
	'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'code', 'pre'
]

const ALLOWED_ATTR = ['href', 'class', 'style', 'target', 'rel']

/**
 * 신뢰 안 된 HTML 문자열을 안전하게 정제한다.
 * XSS 위험 태그/속성(javascript:, onclick 등)은 제거하고
 * 서식 관련 태그/속성(style, class 등)은 유지한다.
 */
export const sanitizeHtml = (text: string) => {
	if (!text) return ''
	return DOMPurify.sanitize(text, { ALLOWED_TAGS, ALLOWED_ATTR })
}